export const GET_PRESCRIPTIONS_LIST = "GET_PRESCRIPTIONS_LIST"
export const CLEAR_PRESCRIPTIONS_LIST = "CLEAR_PRESCRIPTIONS_LIST"